"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var basic_chart_component_1 = require("../../basic-component/basic-chart.component");
var PromiseConfigComponent = /** @class */ (function () {
    function PromiseConfigComponent($scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        // super($scope, $timeout, 'PromiseTracking');
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('promise-tracking:config', function (event, args) {
            ctrl.treeID = args.treeID;
            ctrl.subTreeNameList = args.subTreeNameList || [];
            ctrl.smartorgApi.getPortfolioPromise(args.treeID).then(function (res) {
                if (res) {
                    ctrl.selectedPromise = ctrl.subTreeNameList.find(function (subtreeItem) { return subtreeItem.name === res; });
                }
                else {
                    ctrl.selectedPromise = ctrl.subTreeNameList.reduce(function (promise, subtreeItem) {
                        if (!promise || promise.name.localeCompare(subtreeItem.name)) {
                            return subtreeItem;
                        }
                        return promise;
                    }, null);
                }
                ctrl.originalPromise = ctrl.selectedPromise;
                ctrl.$timeout(function () {
                    ctrl.checkSave();
                    ctrl.$scope.$apply();
                    $("#promiseConfigModal").modal('show');
                });
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err);
            });
        });
    }
    PromiseConfigComponent.prototype.checkSave = function () {
        var ctrl = this;
        ctrl.promiseChanged = (!ctrl.originalPromise || typeof ctrl.originalPromise === 'undefined' || !ctrl.selectedPromise
            || ctrl.originalPromise.name !== ctrl.selectedPromise.name);
    };
    PromiseConfigComponent.prototype.saveConfig = function () {
        console.log('save config triggered!');
        var ctrl = this;
        ctrl.smartorgApi.savePortfolioPromise(ctrl.treeID, ctrl.selectedPromise).then(function (res) {
            ctrl.originalPromise = ctrl.selectedPromise;
            ctrl.promiseChanged = false;
            ctrl.showAlert('success', 'Saved!', '');
            $("#promiseConfigModal").modal('hide');
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err);
        });
    };
    PromiseConfigComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                smartorgApi: '='
            },
            template: require("./promise-config.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], PromiseConfigComponent);
    return PromiseConfigComponent;
}());
angular.module('smartorg.r6.acts.promiseConfig', []).component('promiseConfig', PromiseConfigComponent);
module.exports = 'smartorg.r6.acts.promiseConfig';
//# sourceMappingURL=promise-config.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/promise-tracking/promise-config/promise-config.component.js